// extracted by mini-css-extract-plugin
export default {"box":"error_box__W9EcN"};